<template>

  <v-card
    :disabled="!expand && !completed"
    class="col-12 pa-0 mb-4 bt-step-card"
  >
    <v-card-title>
      {{ title }}
      <v-spacer />
      <v-btn
        v-if="expand"
        :disabled="!valid || !expand"
        small
        color="primary"
        @click="complete"
      >
        Next step
      </v-btn>
    </v-card-title>
    <v-divider v-if="expand" />

    <v-card-text class="pa-0">
      <v-expand-transition>
        <v-form
          v-if="expand"
          v-model="valid"
        >
          <v-container fluid>
            <v-row class="ma-0" justify="center">
              <v-col
                cols="12"
                :md="typeCol"
              >
                <v-row>
                  <v-select
                    v-model="value.type"
                    :items="typesList"
                    label="Bonus Type"
                    :class="{ 'col-5': settings.sticky }"
                    placeholder=" "
                    :rules="[v => !!v || 'Bonus Type is required']"
                    hide-details
                  />

                  <v-switch
                    v-if="settings.sticky"
                    label="Sticky Bonus"
                    class="col-7"
                    style="max-width: 175px;"
                    hide-details
                    v-model="value.sticky_bonus"
                  />
                </v-row>
              </v-col>

              <v-col
                cols="12"
                md="1"
                v-if="settings.wager"
              >
                <v-text-field
                  v-model="value.wager"
                  label="Wager"
                  prefix="x"
                  placeholder=" "
                  :rules="[v => !!v || 'Wager is required']"
                  hide-details
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
              >
                <v-row>
                  <v-text-field
                    v-model="value.lifetime"
                    label="Lifetime"
                    class="col-5 pr-0 settings-bonus-lifetime text-right"
                    suffix="|"
                    type="number"
                    placeholder=" "
                    :rules="[v => !!v || 'Lifetime is required']"
                    hide-details
                  />
                  <v-select
                    v-model="value.lifetime_period"
                    label="Period"
                    class="col-7 pl-0"
                    placeholder=" "
                    :rules="[v => !!v || 'Period is required']"
                    :items="lifetimePeriods"
                    hide-details
                  />
                </v-row>
              </v-col>

              <v-col
                cols="12"
                md="3"
                v-if="settings.game"
              >
                <v-autocomplete
                  label="Game"
                  item-text="name"
                  item-value="game_id"
                  clearable
                  v-model="value.game_id"
                  :items="games"
                >
                  <template slot="item" slot-scope="{ item }">
                    <div style="width: 100%">
                      <span v-html="item.name"></span>
                      <small class="float-right">({{ item.system_name }})</small>
                    </div>
                  </template>

                </v-autocomplete>
              </v-col>

              <v-col
                cols="12"
                md="2"
                v-if="settings.rollover_type"
              >
                <v-select
                  v-model="value.rollover_type"
                  :items="rolloverTypes"
                  label="Rollover Type"
                  placeholder=" "
                  :rules="[v => !!v || 'Rollover Type is required']"
                  hide-details
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
                v-if="settings.release_type"
              >
                <v-select
                  v-model="value.release_type"
                  :items="releaseTypes"
                  label="Release Type"
                  placeholder=" "
                  :rules="[v => !!v || 'Release Type is required']"
                  hide-details
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
                v-if="settings.bonus_type"
              >
                <v-select
                  v-model="value.bonus_type"
                  :items="sportBonusTypes"
                  label="Bonus Type"
                  placeholder=" "
                  :rules="[v => !!v || 'Rollover Type is required']"
                  hide-details
                />
              </v-col>

            </v-row>
          </v-container>
        </v-form>
      </v-expand-transition>
    </v-card-text>
  </v-card>

</template>

<style lang="scss">
  .settings-bonus-lifetime .v-text-field__suffix {
    padding-right: 5px;
  }

  .settings-bonus-lifetime .v-input__slot input {
  }

  .v-card.v-card--disabled .v-card__title {
    background: #cbcbcb;
  }

  .v-card.v-card--disabled.bt-step-card {
    border-left-color: gray;
  }

  .v-card.bt-step-card {
    border-left: 4px solid #4caf50;
  }

</style>

<script>
  import { filter, includes, map, toArray, uniq } from 'lodash'
  import { API } from '@/utils/api'

  export default {

    props: {
      step: {},
      value: {},
      next: {},
      games: {},
      brands: {},
      systems: {},
      extvalid: {},
      exteditable: {},
      extcompleted: {},
      title: {},
      types: {},
      expand: { default: () => false },
    },

    data: () => ({

      releaseTypes: [
        { text: 'Bonus', value: 'bonus' },
        { text: 'Cash', value: 'cash' }
      ],
      rolloverTypes: [
        { type: 'bonus', text: 'Bonus' },
        { type: 'cash', text: 'Cash' }
      ],
      sportBonusTypes: [
        { text: 'Bonus money', value: 'STD' },
        { text: 'Free bet', value: 'FB' },
        { text: 'No Risk Bet', value: 'NRB' },
        { text: 'Free money bet', value: 'FMB' }
      ],
      lifetimePeriods: [
        { text: 'Minutes', value: 'minutes' },
        { text: 'Hours', value: 'hours' },
        { text: 'Days', value: 'days' },
        { text: 'Weeks', value: 'weeks' },
        { text: 'Months', value: 'months' },
      ],
      // valid: false
    }),

    methods: {
      complete () {
        this.completed = true

        this.next(this.step)
      },
    },

    computed: {
      typeCol: function () {
        let colMap = {
          overdraft: 2,
          freespins: 4,
        }
        return colMap[this.value.type] || 3
      },
      settings: function () {
        return this.types[this.value.type] || {}
      },
      typesList: function () {
        return map(toArray(this.types), o => ({ text: o.name, value: o.type }))
      },
      valid: {
        get () {
          return this.extvalid
        },
        set (v) {
          this.$emit('update:extvalid', v)
        }
      },
      editable: {
        get () {
          return this.exteditable
        },
        set (v) {
          this.$emit('update:exteditable', v)
        }
      },
      completed: {
        get () {
          return this.extcompleted
        },
        set (v) {
          this.$emit('update:extcompleted', v)
        }
      },
    },

    watch: {
      expand (v) {
        this.editable = true
      }
    }
  }
</script>

